import { render, staticRenderFns } from "./FormNewDspPartner.vue?vue&type=template&id=ef63fe90&"
import script from "./FormNewDspPartner.vue?vue&type=script&lang=js&"
export * from "./FormNewDspPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports